import React from 'react'
import { Box, Loading } from '@maui/elements'

export const WidgetLoading = () => {
  return (
    <Box
      textAlign="center"
      mt="25%"
      height="100%"
      width="100%"
    >
      <Loading />
    </Box>
  )
}
